import validator from 'validator';
import Errors, { MAX_CHAR, MAX_PHONE_NUMBER } from './validateHelper';

const validateKoinworks = values => {
  const errors = new Errors();
  // ---------- Validate PERSONAL INFORMATION ----------
  errors.validateRequiredFields(values, [
    'name',
    'address',
    'home_city',
    'home_province',
    'home_zipcode',
    'home_phone_number',
    'nik',
    'marital_status',
    'personal_email',
    'personal_phone_number',
    'current_residence_ownership',
  ]);
  if (values.name && values.name.length > MAX_CHAR) {
    errors.name = 'The maximum character is only 255';
  }

  if (values.email && !validator.isEmail(values.email)) {
    errors.email = 'The value is not a valid email address';
  } else if (values.email && values.email.length > MAX_CHAR) {
    errors.email = 'The maximum character is only 255';
  }

  if (values.nik && values.nik.length !== 16) {
    errors.nik = 'please enter the valid ID';
  }

  if (values.personal_email && !validator.isEmail(values.personal_email)) {
    errors.personal_email = 'The value is not a valid email address';
  } else if (values.personal_email && values.personal_email.length > MAX_CHAR) {
    errors.personal_email = 'The maximum character is only 255';
  }

  if (
    values.phone_number &&
    (values.phone_number.length < 9 ||
      values.phone_number.length > MAX_PHONE_NUMBER)
  ) {
    errors.phone_number = 'Please enter a valid phone number';
  }

  if (
    values.home_phone_number &&
    (values.home_phone_number.length < 9 ||
      values.home_phone_number.length > MAX_PHONE_NUMBER)
  ) {
    errors.home_phone_number = 'Please enter a valid phone number';
  }

  // ---------- Validate BUSINESS INFORMATION ----------
  // loan_type must be auto filled
  errors.validateRequiredFields(values, [
    'business_name',
    'email',
    'business_start_month',
    'business_start_year',
    'business_description',
    // 'business_type', not validated but must be filled
    'business_address',
    'business_city',
    'business_contact',
    'business_province',
    'business_zipcode',
  ]);

  if (
    values.business_phone &&
    (values.business_phone.length < 9 ||
      values.business_phone.length > MAX_PHONE_NUMBER)
  ) {
    errors.business_phone = 'Please enter a valid phone number';
  }

  // ---------- Validate BANK INFORMATION ----------
  errors.validateRequiredFields(values, [
    'bank_name',
    'bank_account_name',
    'account_no',
    'bank_branch_name',
  ]);
  if (
    values.bank_name &&
    values.bank_name === 'Other' &&
    (!values.other_bank_name || values.other_bank_name.trim() === '')
  ) {
    errors.other_bank_name = 'Please enter a value';
  } else if (
    values.other_bank_name &&
    values.other_bank_name.length > MAX_CHAR
  ) {
    errors.other_bank_name = 'The maximum character is only 255';
  }

  if (
    values.account_no &&
    (values.account_no.length < 10 || values.account_no.length > 16)
  ) {
    errors.account_no = 'please enter a valid bank account';
  }

  // ---------- validate EMERGENCY CONTACT or Guarantor ----------
  errors.validateRequiredFields(values, [
    'name_emergency',
    'contact_number_emergency',
    'relationship',
    'emergency_address',
  ]);

  if (
    values.contact_number_emergency &&
    (values.contact_number_emergency.length < 9 ||
      values.contact_number_emergency.length > MAX_PHONE_NUMBER)
  ) {
    errors.contact_number_emergency = 'Please enter a valid phone number';
  }

  // ---------- Validate upload documents ----------
  errors.validateJPEGFields(values, [
    'kk',
    'ktp',
    'npwp',
    'bank_statement_array',
  ]);

  if (
    values.marital_status &&
    values.marital_status.toLocaleLowerCase() === 'married'
  ) {
    errors.validateJPEGFields(values, ['ktp_spouse']);
  }

  // bank statement
  const bankStatementsErrors = [];
  if (values.bank_statement_array) {
    values.bank_statement_array.forEach((bankStatement, index) => {
      const memberError = {};
      if (
        !bankStatement.bank_statement ||
        bankStatement.bank_statement.code.trim() === ''
      ) {
        memberError.bank_statement = 'Please upload your bank statement';
      } else if (
        bankStatement.bank_statement &&
        bankStatement.bank_statement.code === 'forbiden type'
      ) {
        memberError.bank_statement = 'Only pdf, jpg, jpeg and png are accepted';
      } else if (
        bankStatement.bank_statement &&
        bankStatement.bank_statement.code === 'file Too Big'
      ) {
        memberError.bank_statement = 'The maximum file size is only 2MB';
      } else if (
        bankStatement.bank_statement &&
        bankStatement.bank_statement.code === 'tampered file'
      ) {
        memberError.bank_statement =
          'The image has been tampered, please upload another one';
      }
      if (Object.keys(memberError).length > 0) {
        bankStatementsErrors[index] = memberError;
      }
    });
  }
  if (bankStatementsErrors.length) {
    errors.bank_statement_array = bankStatementsErrors;
  }
  // --------- IF PERSONAL LOAN, BREAK HERE ---------------------
  if (values.loans_type.toLowerCase() === 'personal') return errors;

  // ---------- FOR BUSINESS ONLY -- Validate upload documents ----------
  errors.validateJPEGFields(values, [
    'akte_perusahaan',
    'ktp_komisaris_url',
    'akte_perubahan',
    'npwp_company',
    'financial_statement',
    'siup',
    'domicile',
    'tdp',
    'bank_statement_company_array',
  ]);

  // bank statment
  const bankStatementsCompanyErrors = [];
  if (values.bank_statement_company_array) {
    values.bank_statement_company_array.forEach((bankStatement, index) => {
      const memberError = {};
      if (
        !bankStatement.bank_statement ||
        bankStatement.bank_statement.code.trim() === ''
      ) {
        memberError.bank_statement =
          'Please upload your bank statement of business';
      } else if (
        bankStatement.bank_statement &&
        bankStatement.bank_statement.code === 'forbiden type'
      ) {
        memberError.bank_statement = 'Only pdf, jpg, jpeg and png are accepted';
      } else if (
        bankStatement.bank_statement &&
        bankStatement.bank_statement.code === 'file Too Big'
      ) {
        memberError.bank_statement = 'The maximum file size is only 2MB';
      } else if (
        bankStatement.bank_statement &&
        bankStatement.bank_statement.code === 'tampered file'
      ) {
        memberError.bank_statement =
          'The image has been tampered, please upload another one';
      }
      if (Object.keys(memberError).length > 0) {
        bankStatementsCompanyErrors[index] = memberError;
      }
    });
  }
  if (bankStatementsCompanyErrors.length) {
    errors.bank_statement_company_array = bankStatementsCompanyErrors;
  }
  return errors;
};

export default validateKoinworks;
